import { useLayoutEffect, useState } from 'react';

/** Observe the natural height of content inside a separately clipped container. */
const useMeasuredHeight = () => {
  const [element, setElement] = useState<HTMLDivElement | null>(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!element) {
      setHeight(0);
      return;
    }

    const measure = () => setHeight(element.getBoundingClientRect().height);
    measure();

    // Also catches reflow, font/image loading, translations and edited content,
    // including changes that leave the outer collapsed height unchanged.
    const observer = new ResizeObserver(measure);
    observer.observe(element);
    return () => observer.disconnect();
  }, [element]);

  return [setElement, height] as const;
};

export { useMeasuredHeight };
